import { render } from "./AposCommandMenuShortcut.vue?vue&type=template&id=6c33b895&scoped=true"
import script from "./AposCommandMenuShortcut.vue?vue&type=script&lang=js"
export * from "./AposCommandMenuShortcut.vue?vue&type=script&lang=js"

import "./AposCommandMenuShortcut.vue?vue&type=style&index=0&id=6c33b895&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c33b895"],['__file',"command-menu/ui/apos/components/AposCommandMenuShortcut.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c33b895"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c33b895', __exports__)) {
    api.reload('6c33b895', __exports__)
  }
  
  module.hot.accept("./AposCommandMenuShortcut.vue?vue&type=template&id=6c33b895&scoped=true", () => {
    api.rerender('6c33b895', render)
  })

}


export default __exports__